/**
 * 牌價網變數格嘅輸入：純數字，逗號淨係顯示用（`2,500,000`），計之前剝走。
 * 唔合法（空白、字母、多過一個小數點）就當未填。
 */
export const parseVariableExpression = (raw) => {
  const text = String(raw ?? '').replace(/[\s,]/g, '');
  if (!text) return null;
  if (!/^-?\d*\.?\d+$/.test(text)) return null;
  const n = Number(text);
  return Number.isFinite(n) ? n : null;
};

/**
 * 打字時即場清乾淨 + 加千分位：**只准數字同一個小數點**，其餘（英文字母、符號、多過一個
 * 小數點）直接掉走 —— 個 input 係 `type="text"`（`number` 顯示唔到千分位），唔喺呢度擋
 * 就打得英文字入去。未打完嘅小數點（`1234.`）原樣保留。
 *
 * 負數要留返個 `-`，但**只認最頭嗰個** —— 中間嘅 `-` 係減數，`parseVariableExpression`
 * 收唔到（佢個 regex 係 `^-?…`），留住只會變咗個永遠計唔到嘅值。
 */
export const formatVariableInput = (raw) => {
  const source = String(raw ?? '');
  const sign = source.trimStart().startsWith('-') ? '-' : '';
  const digitsAndDot = source.replace(/[^\d.]/g, '');
  const firstDot = digitsAndDot.indexOf('.');
  const text = firstDot === -1
    ? digitsAndDot
    : `${digitsAndDot.slice(0, firstDot + 1)}${digitsAndDot.slice(firstDot + 1).replace(/\./g, '')}`;
  // 淨係打咗個 `-`：留住畀佢打埋落去（`parseVariableExpression('-')` 係 null = 當未填）。
  if (!text) return sign;
  return sign + text.replace(/\d+(\.\d*)?/g, (num) => {
    const [intPart, decPart] = num.split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decPart === undefined ? grouped : `${grouped}.${decPart}`;
  });
};
